import { getRuntimeConfig } from '@catawiki/next-config/runtime-config';

export const isServerRequest = () => typeof window === 'undefined';

export const getBaseDomain = () =>
  isServerRequest()
    ? `http://${process.env.CW_API_ENDPOINT ?? ''}`
    : `${getRuntimeConfig().protocol}://${getRuntimeConfig().baseDomain ?? ''}`;

export const getCsrfRoute = () =>
  `${getBaseDomain()}/accounts/api/v1/users/csrf`;

export const getAuctionsRoute = () =>
  `${getBaseDomain()}/buyer/api/v1/auctions`;
export const getPopularAuctionsRoute = () =>
  `${getBaseDomain()}/buyer/api/v1/auctions/popular`;
export const getLotsRoute = () => `${getBaseDomain()}/buyer/api/v1/lots`;
export const getLotPricesRoute = () =>
  `${getBaseDomain()}/buyer/api/v3/bidding/lots`;
export const getMenuCategoriesRoute = () =>
  `${getBaseDomain()}/buyer/api/v1/menu`;
export const getCategoriesRoute = () =>
  `${getBaseDomain()}/buyer/api/v1/categories`;
export const expertRoute = (expertId: number) =>
  `${getBaseDomain()}/buyer/api/v1/experts/${expertId}`;
export const collectionInfoRoute = (collectionId: number) =>
  `${getBaseDomain()}/collections/api/v1/collections/${collectionId}`;

export const userRoutes = {
  me: () => `${getBaseDomain()}/buyer/api/v1/users/me`,
  favorites: () => `${getBaseDomain()}/buyer/api/v1/users/me/favorites`,
  interestsLots: () =>
    `${getBaseDomain()}/buyer/api/v1/users/me/interests/lots`,
};
